import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
export const registerUser = (
  username,
  email,
  password,
  password2,

  gender
) => {
  //Headers
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  //Request body
  const user = {
    username,
    email,
    password,
    password2,

    gender,
  };
  const body = JSON.stringify(user);
  const promise = axios.post(
    " https://eutracker.rdiup.com/api/register/",
    body,
    config
  );

  const dataPromise = promise.then((response) => response.data.key);
  return dataPromise;
};

export const loginUser = (username, password) => {
  //Headers
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  //Request body

  const body = JSON.stringify({ username, password });
  const promise = axios.post(
    " https://eutracker.rdiup.com/api/login/",
    body,
    config
  );

  const dataPromise = promise.then((response) => response.data.key);
  return dataPromise;
};

export const logout = (refresh_token) => {
  //Headers
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  //Request body

  const body = JSON.stringify({ refresh_token });
  const promise = axios.post(
    " https://eutracker.rdiup.com/api/logout/",
    body,
    config
  );

  const dataPromise = promise.then((response) => response.data.key);
  return dataPromise;
};

export const reset_password = (email) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const body = JSON.stringify({ email });

  axios
    .post(` https://eutracker.rdiup.com/api/request-reset-email/`, body, config)
    .then((response) => {
      console.log(response);
      Swal.fire({
        title: "Success!",
        text: "Email sent successful",
        icon: "success",
      });
    })
    .catch((error) => {
      console.log(error);
      window.alert("Error trying to update" + error);
    });
  return true;
};

export const reset_password_confirm = (uid, token) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  //const body = JSON.stringify({ password });

  axios
    .get(
      ` https://eutracker.rdiup.com/api/password-reset/` + uid + "/" + token,
      config
    )
    .then((response) => {
      console.log(response);
    })
    .catch((error) => {
      console.log(error);
      window.alert("Error trying to update" + error);
    });
  return true;
};

export const reset_password_complete = (password, uidb64, token, navigate) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const body = JSON.stringify({ password, uidb64, token });

  axios
    .patch(
      ` https://eutracker.rdiup.com/api/password-reset-complete/`,
      body,
      config
    )
    .then((response) => {
      console.log(response);
      Swal.fire({
        title: "Success!",
        text: "Reset password successful. Redirecting to login...",
        icon: "success",
        confirmButtonText: "OK",
      });
      navigate("/");
    })
    .catch((error) => {
      console.log(error);
      window.alert("Error trying to update" + error);
    });
  return true;
};
